// extracted by mini-css-extract-plugin
export default {"subform-block":"ResetPasswordForm_subform-block__SqbxE"};